import { Empty } from "antd";
import { useState } from "react";
import { UploadFileResponse } from "../../../redux/api/apiTypes";
import { Swiper as SwiperElement, SwiperSlide } from "swiper/react";
import { Swiper } from 'swiper/types/index';
import { FreeMode, Navigation, Thumbs } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

interface Props {
    imageList: UploadFileResponse[];
}

const AuctionSwiper = ({ imageList }: Props) => {
    const [thumbsSwiper, setThumbsSwiper] = useState<Swiper>();

    return (
        <>
            {imageList.length === 0 && <Empty />}
            {imageList.length === 1 &&
                <img
                    alt="product"
                    style={{ width: '100%', objectFit: 'scale-down', maxHeight: 350 }}
                    src={process.env.REACT_APP_API_URL + `/files/downloadFile/${imageList[0].attachmentId}`} />}
            {imageList.length > 1 &&
                <>
                    <SwiperElement
                        // loop={true}
                        spaceBetween={10}
                        onSwiper={setThumbsSwiper}
                        freeMode={true}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className="custom-swiper"
                        watchSlidesProgress={true}
                    >
                        {imageList.map(item => (
                            <SwiperSlide key={item.attachmentId}>
                                <img
                                    alt="product"
                                    style={{ objectFit: 'scale-down', width: '100%', height: '100%' }}
                                    src={process.env.REACT_APP_API_URL + `/files/downloadFile/${item.attachmentId}`} />
                            </SwiperSlide>
                        ))}

                    </SwiperElement>
                    <div>
                        <SwiperElement
                            navigation={{
                                nextEl: '.swiper-button-next-unique',
                                prevEl: '.swiper-button-prev-unique'
                            }}
                            thumbs={{ swiper: thumbsSwiper }}
                            spaceBetween={10}
                            slidesPerView={imageList.length < 4 ? imageList.length : 4}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className="custom-swiper-thumbnails"
                            slideToClickedSlide
                            centeredSlides
                        >
                            {imageList.map(item => (
                                <SwiperSlide key={item.attachmentId}>
                                    <img
                                        alt="product"
                                        style={{ objectFit: 'scale-down', width: '100%', height: '100%', cursor: 'pointer' }}
                                        src={process.env.REACT_APP_API_URL + `/files/downloadFile/${item.attachmentId}`} />
                                </SwiperSlide>
                            ))}

                        </SwiperElement>
                        <div className="swiper-button-prev-unique">
                            <LeftOutlined />
                        </div>
                        <div className="swiper-button-next-unique">
                            <RightOutlined />
                        </div>

                    </div>
                </>
            }
        </>
    )
}

export default AuctionSwiper;